var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "alert-chart-app" } },
    [
      _c(
        "v-container",
        {
          staticClass: "highcharts-light alert-chart-container",
          attrs: { fluid: "" },
        },
        [
          _c("v-card", { attrs: { outlined: "" } }, [
            _c("div", { staticClass: "chart-title" }, [
              !(_vm.filterBy && _vm.categoryDisplay && _vm.metricDisplay)
                ? _c("span", [_vm._v(" ")])
                : _vm._e(),
              _vm._v(" "),
              _vm.filterBy && _vm.categoryDisplay && _vm.metricDisplay
                ? _c("span", [
                    _c("span", [
                      _vm._v(
                        "For all " +
                          _vm._s(_vm.categoryDisplay) +
                          " where " +
                          _vm._s(_vm.filterByShort)
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.filterBy && _vm.categoryDisplay && _vm.metricDisplay
                ? _c("span", [
                    _c("span", [
                      _vm._v("For all " + _vm._s(_vm.categoryDisplay)),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.splitSeries && _vm.chartsSeries && _vm.chartsSeries.length > 1
                ? _c("span", [
                    _c("span", { staticClass: "group-info" }, [
                      _vm._v("(Showing "),
                      _c("span", [_vm._v(_vm._s(_vm.chartsSeries.length))]),
                      _vm._v(" of "),
                      _c("span", [_vm._v(_vm._s(_vm.data.size) + ")")]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.splitSeries &&
              _vm.chartsSeries &&
              _vm.chartsSeries[0].length > 1
                ? _c("span", [
                    _c("span", { staticClass: "group-info" }, [
                      _vm._v("(Showing "),
                      _c("span", [_vm._v(_vm._s(_vm.chartsSeries[0].length))]),
                      _vm._v(" of "),
                      _c("span", [_vm._v(_vm._s(_vm.data.size))]),
                      _vm._v(")"),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "section",
              {
                style:
                  "max-height:" +
                  _vm.height +
                  "px; height:" +
                  _vm.height +
                  "px; overflow-y: auto;",
              },
              [
                _c(
                  "v-container",
                  { staticClass: "pa-0", attrs: { fluid: "" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "vy-row pa-0 ma-0",
                        attrs: { "no-gutters": "" },
                      },
                      [
                        _c(
                          "v-overlay",
                          {
                            attrs: {
                              absolute: "",
                              opacity: "1",
                              value: _vm.loading,
                              color: "var(--panel-background)",
                            },
                          },
                          [
                            _c("v-progress-circular", {
                              attrs: {
                                indeterminate: "",
                                color: "var(--primary-btn-bg-color)",
                                size: "64",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.chartsSeries, function (series, index) {
                          return _c(
                            "v-col",
                            {
                              key: "alert-chart-" + index + "-" + _vm.chartId,
                              staticClass: "pa-0 ma-0",
                              attrs: {
                                cols: "12",
                                lg:
                                  _vm.isViewMode && _vm.multipleChartsWide
                                    ? "6"
                                    : "12",
                                xl:
                                  _vm.isViewMode && _vm.multipleChartsWide
                                    ? "3"
                                    : _vm.multipleChartsWide
                                    ? "6"
                                    : "12",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "alert-chart-container-wrapper",
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "highcharts-light alert-chart-container",
                                    attrs: {
                                      id:
                                        "alert-chart-" +
                                        index +
                                        "-" +
                                        _vm.chartId,
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }